import * as Sentry from '@sentry/browser';
import { Component, Prop, State, h, EventEmitter, Event } from '@stencil/core';

@Component({
  tag: 'ike-link',
  shadow: false,
})
export class IkeLink {
  link!: HTMLAnchorElement;

  @Prop() url?: string;
  @Prop() activeClass: string = 'link-active';
  @Prop() classes: string = '';
  @Prop() rel: string = '';
  @Prop() forceUrl: string|null = null;
  @Prop() scrollTopAction: boolean = true;

  /**
   *  Custom tag to use instead of an anchor
   */
  @Prop() anchorClass?: string;
  @Prop() anchorRole?: string;
  @Prop() anchorTitle?: string;
  @Prop() anchorTabIndex?: string;
  @Prop() anchorId?: string;

  @Prop() ariaHaspopup?: string;
  @Prop() ariaPosinset?: string;
  @Prop() ariaSetsize?: number;


  @State() match: boolean;

  @Event() ike_scroll_to_top: EventEmitter;
  @Event() getUtils: EventEmitter;
  private utils: any;
  componentWillLoad() {
    this.getUtils.emit(utils=>this.utils=utils);
  }

  private handleClick(e: MouseEvent) {
    e.preventDefault();
    if(this.scrollTopAction) {
        this.ike_scroll_to_top.emit();
    }

    if (this.forceUrl) {
      Sentry.captureMessage('redirecting to '+this.forceUrl, 'info');
      window.location.href = this.forceUrl;
      return;
    }

    return this.utils.goTo(this.url);
  }

  private initLink(): HTMLAnchorElement {
    const link = document.createElement('a');
    this.link = link;
    return link;
  }

  render() {
    let anchorAttributes: { [key: string]: any} = {
      class: {
        [this.activeClass]: this.match,
      },
      onClick: this.handleClick.bind(this)
    }

    if (this.anchorClass) {
      anchorAttributes.class[this.anchorClass] = true;
    }

    let link = this.initLink()
    link.href += this.url

    anchorAttributes = {
      ...anchorAttributes,
      href: this.forceUrl ? this.forceUrl : this.url,
      title: this.anchorTitle,
      role: this.anchorRole,
      tabindex: this.anchorTabIndex,
      id: this.anchorId,
      class : this.classes,
      rel: this.rel,
    }

    return <a ref={() => link} {...anchorAttributes}><slot/></a>;
  }
}
